import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, string } from "yup";
import { useDispatch, useSelector } from "react-redux";
import { changeChain, resetFilters } from "../redux/chainsSagas";
import { useError } from "../../../../hooks/useError";
import { api } from "../api";
import { MainModal } from "../../../../components/modal/MainModal";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { ErrorList } from "../../../../components/ErrorList";
import { ChainFilters } from "./ChainFilters";

const schema = object({
  name: string().label("Name").required()
}).required();

export const Edit = ({ isOpen, onClose, selectedChain: { id, chainName, orgName } }) => {
  const dispatch = useDispatch();

  const { storeStatuses, isAddNewStoreDisabled } = useSelector(
    (state) => state.chains.commonSettings
  );

  const getDefaultValues = async () => {
    let { data } = await api.getChainInfo({ params: { id: id.toString() } });

    const { add_new_store, active_store_statuses, uid, name } = data;

    return {
      name,
      uid,
      add_new_store,
      active_store_statuses: storeStatuses.filter((status) =>
        active_store_statuses.includes(status.id)
      )
    };
  };

  const {
    register,
    handleSubmit,
    control,
    formState: { isLoading, dirtyFields, errors }
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: getDefaultValues
  });

  const close = () => {
    dispatch(resetFilters());
    onClose();
  };

  const { errors: serverErrors, status } = useError({ cb: close, sliceKey: "chains" });

  const onSubmit = async (data) => {
    dispatch(changeChain({ id, data, dirtyFields, orgName }));
  };

  const primaryButtonDisabled =
    (dirtyFields && Object.keys(dirtyFields).length === 0) || status == "pending";

  return (
    <>
      <MainModal
        isLoading={isLoading}
        isOpen={isOpen}
        onClose={close}
        parentSelector=".chains"
        headerText={`Edit Clubready Chain - ${chainName}`}
        headerCloseHandler={close}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={handleSubmit(onSubmit)}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={close}
        height="auto"
        width={850}
      >
        <form>
          <ChainFilters
            isEditMode
            control={control}
            register={register}
            isAddNewStoreDisabled={isAddNewStoreDisabled}
            storeStatuses={storeStatuses}
          />

          {status === "pending" && <LoadingAnimation uiLoader />}
          <ErrorList errors={{ ...errors, ...serverErrors }} />
        </form>
      </MainModal>
    </>
  );
};
